package com.vizio.redwolf.consent.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class ConsentV2DataResponse(
    val consents: List<ConsentData>? = null,
    val consentGroups: List<ConsentGroup>? = null,
    val consentActions: List<ConsentActionData>,
    val consentToken: String,
)

@Serializable
@JsExport
data class ConsentData(
    val id: String? = null,
    val version: Int? = null,
    val title: String? = null,
    val language: String? = null,
    @SerialName("text") val textUrl: String? = null,
    @SerialName("html") val htmlUrl: String? = null,
    @SerialName("css") val cssUrls: List<String> = emptyList(),
)

@Serializable
@JsExport
data class ConsentGroup(
    val id: String,
    val title: String,
    val required: Boolean,
    val language: String,
    val consents: List<ConsentGroupData>
)

@Serializable
@JsExport
data class ConsentGroupData(
    val id: String,
    @SerialName("name") val title: String,
)

@Serializable
@JsExport
data class ConsentActionData(
    val action: String,
    val title: String
)

